import { FetchPetsPostingLimitParams } from '@gumtree/ui-library/src/pets-posting-limit/type';
import { AUTO_RENEW_TYPE } from './auto-renew-feature';

export interface PriceMetadataItem {
    clientValue: string;
    displayValue: string;
    free: boolean;
    includedInPackage: boolean;
    price: number;
    /** e.g. `FEATURE_3_DAY` */
    productName: PriceMetadataValue;
    /** e.g. `FEATURED` */
    productType: FeatureType | 'BUMP_UP' | 'INSERTION';
    value: PriceMetadataValue;
}

/** Also the `productName` */
export type PriceMetadataValue =
    | 'URGENT'
    | 'INSERTION'
    | 'HOMEPAGE_SPOTLIGHT'
    | 'FEATURE_3_DAY'
    | 'FEATURE_7_DAY'
    | 'FEATURE_14_DAY'
    | 'WEBSITE_URL'
    | 'BUMP_UP';

export type FeatureType =
    | 'FEATURED'
    | 'SPOTLIGHT'
    | 'URGENT'
    | 'WEBSITE_URL'
    | 'NOT_VISIBLE_PRODUCT';

export type PricingMetadata = {
    bumpUpPrice: PriceMetadataItem | null;
    /** Saw BUMP_UP on edit ad page */
    featureOptions: Record<FeatureType, FeatureOptions>;
    insertionPrice: PriceMetadataItem;
};

export type FeatureAutoRenewOption = {
    hoveredPlan?: string | null;
    selected?: boolean;
    activatingPlan?: string | null;
    nextRenewDate?: number | null;
    autoRenewContractId?: number | null;
};

export type FeatureAutoRenewOptions = Partial<Record<AUTO_RENEW_TYPE, FeatureAutoRenewOption>>;

export interface FeatureOptions {
    active: boolean;
    description: string;
    expiryDescription: null | string;
    prices: PriceMetadataItem[] | null;
    type: FeatureType;
}

export type AutoRenewMetadata = Record<AUTO_RENEW_TYPE, AutoRenewFeatureOptions>;

export interface AutoRenewFeatureOptions {
    available: boolean;
    plans: string[];
    defaultSelected?: boolean;
}

export const SyiTrackingActions = {
    EDIT: 'EditAdAttempt',
    REPOST: 'RepostAdAttempt',
    CATEGORY: 'PostAdCategory',
    LOCATION: 'LocationSelect',
    LOCATION_UPDATE: 'LocationUpdate',
    SELLER: 'SellerTypeSelected',
    FORM_FREE: 'PostAdFreeAttempt',
    FORM_PAID: 'PostAdPaidAttempt',
} as const;

export interface SyiDispatchPetsPostingLimitProps
    extends Omit<FetchPetsPostingLimitParams, 'sellerUrl'> {
    l1CategoryId?: string | number;
    l2CategoryId?: string | number;
    l3CategoryId?: string | number;
    skipPetsPostingLimitCheck?: boolean;
}
